import { render, staticRenderFns } from "./AccRecvProfile.vue?vue&type=template&id=548f7bf2&"
import script from "./AccRecvProfile.vue?vue&type=script&lang=js&"
export * from "./AccRecvProfile.vue?vue&type=script&lang=js&"
import style0 from "./AccRecvProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports